<section class="jackpot clearfix">
    <div class="jackpot_container">
      <div class="jackpot_left col-md-4 pl0">
        <div class="jackpot_left--item">
          <h4>{{'jackpot.why_play' | translate }}</h4>
          <h1>
            {{'jackpot.experience' | translate}}<br>{{'jackpot.like' | translate}}<br>{{'jackpot.alegend' | translate}}
          </h1>
          <ul>
            <li>{{'jackpot.instantdeposits' | translate}}</li>
            <li>{{'jackpot.fast_withdrawals' | translate}}</li>
            <li>{{'jackpot.minute_registration' | translate}}</li>
            <li>{{'jackpot.thousands_games' | translate}}</li>
          </ul>
          <div class="text-center" *ngIf="isCountryAllowed === 2">
            <button class="site-btn site-btn--xm site-btn__primary w-260"
              (click)="register()">{{'jackpot.create_an_account' | translate}}</button>
          </div>
          <div class="text-center"  *ngIf="isCountryAllowed === 1">
            <button class="site-btn site-btn--xm site-btn__primary w-260"
            (click)="moveToTrustlyPay()" *ngIf="isCountryAllowed === 1">{{'payandplay.deposit' | translate}}</button>
          </div>
        </div>
      </div>
      <div class="jackpot_right col-md-8 pr-0 pl0">
        <div class="jackpot_right--amount">
          <div class="jackpot_right--item jackpot-amount" [ngStyle]="{'background': 'url(' + bonusBg + ') no-repeat left top/100%'}">
          <h2>{{'jackpot.shared_jackpot1' | translate }}<br>{{'jackpot.shared_jackpot2' | translate}}</h2>
          <a href="javascript:void(0)" (click)="register()">{{'jackpot.claimNow' | translate }}</a>
        </div>
        </div>
        <div class="jackpot_right--item carousel_slider">
          <app-carousel-banner></app-carousel-banner>
        </div>
      </div>
    </div>
</section>